import React from 'react';
import { formatNumber } from 'utils/formatter';
import { PremiumCheck2 as PremiumCheck } from 'components/commons/premium-check/PremiumCheck';
import {
  calculateRemainTargetDate,
  useBirthday,
} from 'components/features/target-achievement-support/utils/birthday';
import { targetTypeToIconImg } from 'components/features/target-achievement-support/utils/targetInfo';
import { Target } from 'components/features/target-achievement-support/utils/type';
import { NotFoundBirthday } from '../birthday/NotFoundBirthday';
import { TargetPremium } from '../TargetPremium';

export const TargetBasicInfoForm = ({
  target,
  update,
}: {
  target: Target;
  update?: () => void;
}) => {
  const { birthday } = useBirthday();

  if (birthday === null || birthday === undefined)
    return (
      <>
        <PremiumCheck content={<TargetPremium />}>
          <NotFoundBirthday />
        </PremiumCheck>
      </>
    );

  const { age, month, year } = calculateRemainTargetDate({
    birthday,
    targetDate: new Date(target.endDate),
  });

  return (
    <div className="p-4 mx-2 bg-white rounded-lg shadow">
      <div className="w-full flex flex-row items-center">
        <img
          src={targetTypeToIconImg(target.refType)}
          alt="目標アイコン"
          className="w-12 h-12 rounded-full border"
          style={{ borderColor: '#dee5ee', objectFit: 'cover' }}
        />
        <div className="w-full ml-2 text-sm text-bluegray-700">
          <div className="flex flex-row">
            <div className="text-base font-bold">{target.title}</div>
            {update ? (
              <div
                className="flex flex-row ml-auto text-xs text-blue-700 cursor-pointer"
                onClick={() => update()}>
                <div>変更</div>
                <div className="icon-edit text-sm ml-2" />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div>
            目標金額
            <span className="ml-2">
              {formatNumber(target.targetAmount / 10000, {})}
              万円
            </span>
          </div>
          <div className="flex flex-row items-center text-sm">
            目標まで
            <span className="ml-2">
              {year ? `${year}年` : ''}
              {month ? `${month}ヶ月` : ''}（{age}歳）
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
